import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737c2b67"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "wrapper__top" }
const _hoisted_3 = { class: "wrapper__bottom" }
const _hoisted_4 = { class: "app-progress" }
const _hoisted_5 = { class: "app-progress__bar bar" }
const _hoisted_6 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_7 = { class: "d-wrapper__top" }
const _hoisted_8 = { class: "d-wrapper__bottom" }
const _hoisted_9 = { class: "d-app-progress" }
const _hoisted_10 = { class: "d-app-progress__bar bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$localize('upload.media.stripe.progress')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.uploadInfo.counter) + " " + _toDisplayString(_ctx.$localize('upload.of.stripe.progress')) + " " + _toDisplayString(_ctx.uploadInfo.total), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                style: _normalizeStyle('width: ' + _ctx.percentage + '%'),
                class: "bar__item"
              }, null, 4)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$localize('upload.media.stripe.progress')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.uploadInfo.counter) + " " + _toDisplayString(_ctx.$localize('upload.of.stripe.progress')) + " " + _toDisplayString(_ctx.uploadInfo.total), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                style: _normalizeStyle('width: ' + _ctx.percentage + '%'),
                class: "bar__item"
              }, null, 4)
            ])
          ])
        ])
      ]))
}